import React from "react";
import {Box, Grid, Typography, useMediaQuery} from "@mui/material";
import theme from "../../elements/Theme";
import OrangeHighlightButton from "../../elements/OrangeHighlightButton";
import {useHistory} from "react-router-dom";
import ResizableImage from "../../elements/ResizableImage";


const ReserveNPricingLinkFrame: React.FC = () => {
    let history = useHistory();
    const handleClick = (path: string) => {
        history.push(`/${path}`)
    }
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    return (
        <Box
            sx={{
                backgroundColor: theme.palette.primary.main,
                display: 'flex',
                flexDirection: 'column',
                px: isMobile ? '20px' : '73px',
                my: isMobile ? '10vh' : '20vh',
                
            }}
        >
            <Typography variant='h2' mx='auto' mb='5vh'>
                A pathway to future success
            </Typography>
            <Grid container spacing={isMobile ? 5 : 20}>
                <Grid item xs={12} md={7} style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
                    <Typography variant={'h3'} fontWeight={400}>
                        “At Young Sparrows, we collaborate with families to nurture each child's growth. Our goal is to
                        guide them into becoming confident, responsible, reflective, innovative, and engaged young
                        individuals.<br/><br/>
                        Our Cambridge International School programs lay exceptional foundations for future education.
                        They are tailored to discover your child’s unique talents, teaching resilience through
                        challenges and framing setbacks as vital steps towards growth and success.”<br/><br/>
                        Anna Poletaeva,<br/>
                        Director of Young Sparrows international primary school
                    </Typography>
                </Grid>
                <Grid item xs={6} md={5} order={isMobile ? -1 : 1}>
                    <ResizableImage src={'/homePage/director.jpeg'}/>
                </Grid>
            </Grid>

            <Box mt='5vh' sx={{display: 'flex', flexDirection: isMobile ? 'column' : 'row', justifyContent: 'space-evenly', alignItems: 'center'}}>
                <Box>
                    <OrangeHighlightButton onClick={() => handleClick('our-program')}>
                        <Typography variant='h3' color={theme.palette.text.secondary} fontFamily='Open Sans Bold'>
                            PROGRAM
                        </Typography>
                    </OrangeHighlightButton>
                </Box>
                <Box sx={{mt: isMobile ? '1.5rem' : '0'}}>
                    <OrangeHighlightButton onClick={() => handleClick('pricing')}>
                        <Typography variant='h3' color={theme.palette.text.secondary} fontFamily='Open Sans Bold'>
                            PRICING
                        </Typography>
                    </OrangeHighlightButton>
                </Box>
            </Box>
        </Box>
    )
}


export default ReserveNPricingLinkFrame;